function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{stroke:#7a9af6;stroke-linecap:round;stroke-linejoin:round;stroke-width:9px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-691.589 -65.674)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(691.589 65.674)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.545)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-1076.41-135.93l-6.135,4.87a2.493,2.493,0,0,1-1.717.678,2.493,2.493,0,0,1-1.717-.678l-6.156-4.892a.99.99,0,0,1-.158-1.39.959.959,0,0,1,1.364-.158l5.559,4.437v-9.026a1.039,1.039,0,0,1,1.043-1.021.918.918,0,0,1,.677.3.987.987,0,0,1,.256.722v9.094l5.7-4.483a1.021,1.021,0,0,1,1.415.158A.987.987,0,0,1-1076.41-135.93Z",
  transform: "translate(1092.508 143.11)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(9.78 11.743)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M-1055-89.626",
  transform: "translate(1055 89.626)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 11.35)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-1080.971-84.771h-17.584a.988.988,0,0,1-.988-.988v-4.669a.988.988,0,0,1,.988-.988.988.988,0,0,1,.988.988v3.681h15.608v-3.681a.988.988,0,0,1,.988-.988.988.988,0,0,1,.988.988v4.669A.988.988,0,0,1-1080.971-84.771Z",
  transform: "translate(1099.543 91.416)"
}))));

var SvgDownload = function SvgDownload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.56,
    height: 17.995,
    viewBox: "0 0 19.56 17.995",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/download.e84d54e4.svg";
export { ForwardRef as ReactComponent };